<template>
  <div class="account-login">
    <a-form :form="loginForm">
      <a-form-item>
        <a-input
          v-decorator="[
            'username',
            {
              rules: [
                { required: true, message: '请输入账号', trigger: 'blur' },
              ],
            },
          ]"
          placeholder="请输入账号"
        >
          <img class="sjh" slot="prefix" src="@/assets/images/sj.png" alt="" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input
          type="password"
          v-decorator="[
            'password',
            { rules: [{ required: true, message: '请输入密码' }] },
          ]"
          placeholder="请输入密码"
        >
          <img class="sjh" slot="prefix" src="@/assets/images/ys.png" alt="" />
        </a-input>
      </a-form-item>
    </a-form>
    <div class="login-button" @click="login">登 录</div>
    <div class="login-yhxy-box">
      <a-checkbox v-model="agree" @change="checkChange">
        我已阅读并同意<a href="">《用户协议》</a>和<a href="">《隐私政策》</a>
      </a-checkbox>
    </div>

    <Verify
      ref="verify"
      mode="pop"
      captcha-type="blockPuzzle"
      :img-size="{ width: '330px', height: '155px' }"
      @success="verifySuccess"
    />
  </div>
</template>

<script>
import Verify from "@/components/Verifition/Verify.vue";
import { message } from "ant-design-vue";
import { postPasswordLogin } from "@/api/layout";
import { scretPassword } from "@/utils/common-method";

export default {
  components: { Verify },
  data() {
    return {
      agree: false,
      loginForm: this.$form.createForm(this),
      captcha: undefined,
    };
  },
  methods: {
    login() {
      this.loginForm.validateFields((err) => {
        if (!err) {
          if (this.agree) {
            this.$refs.verify.show();
          } else {
            message.error("请先同意用户协议和隐私政策");
          }
        }
      });
    },
    // 验证码获取成功
    verifySuccess(params) {
      this.captcha = params.captchaVerification;
      this.submitForm();
    },

    // 提交信息
    submitForm() {
      const data = {
        state: Math.random(),
        captcha: this.captcha,
        username: this.loginForm.getFieldValue("username"),
        password: scretPassword(this.loginForm.getFieldValue("password")),
      };
      postPasswordLogin(data).then((res) => {
        if (res && res.code === 200) {
          message.success(res.message || "登录成功");
          this.$emit("success", res.result);
        } else {
          message.error(res.message || "登录失败");
        }
      });
    },
    checkChange(event) {
      this.agree = event.target.checked;
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.account-login {
  margin-top: 25px;

  .sjh {
    width: 16px;
    height: 16px;
  }

  .tip {
    font-weight: 400;
    font-size: 14px;
    color: #dddddd;
    line-height: 24px;
  }

  .yzm-button {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 22px;

    &:hover {
      cursor: pointer;
    }
  }

  .yzm-disable {
    color: #d9d9d9;
  }

  .login-button {
    width: 340px;
    height: 40px;
    background-color: #0067db;
    border-radius: 2px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }

  .login-yhxy-box {
    margin-top: 16px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 22px;
  }

  ::v-deep(.ant-input, .ant-input-affix-wrapper) {
    width: 340px;
    height: 40px;
    outline: none;
    box-shadow: none;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
  }
}
</style>
